import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from '@immo/ui-kit';
import { ModalDefaults } from '@/components/modal-defaults';
import { ReleaseNoticeBridge } from '@/components/release-notice-bridge';
import { ToastBusBridge } from '@/components/toast-bus-bridge';
import { I18nProvider } from '@/i18n/provider';
import { router } from '@/router';

export function App() {
  return (
    <I18nProvider>
      <ModalDefaults>
        <ToastProvider>
          <ToastBusBridge />
          <ReleaseNoticeBridge />
          <RouterProvider router={router} />
        </ToastProvider>
      </ModalDefaults>
    </I18nProvider>
  );
}
